import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { useTranslation } from "react-i18next";
import {
  IoCallOutline,
  IoCheckmarkCircleOutline,
  IoDocumentTextOutline,
  IoGlobeOutline,
  IoLocationOutline,
  IoMailOutline,
} from "react-icons/io5";
import Footer from "../../Components/Footer/Footer";
import Nav from "../../Components/Navnew/Nav";
import { companyInfo } from "../../data/company";

const fallbackPopularTours = [
  {
    isTop: true,
    _id: "674579310f0debd431d254ea",
    title_eng: "Uzbekistan Grand Tour (10 Days)",
    title_ru: "По городам Узбекистана (10 дней)",
    title_uz: "O‘zbekiston bo‘ylab katta sayohat (10 kun)",
    description_eng:
      "<p>This 10-day cultural journey includes Tashkent, Nukus, Muynak, Khiva, Bukhara, Shakhrisabz, and Samarkand with guided visits, transport, and hotels.</p>",
    description_ru:
      "<p>10-дневный тур по Узбекистану с посещением Ташкента, Нукуса, Муйнака, Хивы, Бухары, Шахрисабза и Самарканда, включая транспорт, гидов и проживание.</p>",
    description_uz:
      "<p>Toshkent, Nukus, Mo‘ynoq, Xiva, Buxoro, Shahrisabz va Samarqand bo‘ylab 10 kunlik tur. Transfer, gid va mehmonxona kiritilgan.</p>",
    location: "Toshkent, Nukus, Mo‘ynoq, Xiva, Buxoro, Shahrisabz, Samarqand",
    price: 1800,
    img: "https://tur.web-sayt.uz/uploads/a81a95a7-5f58-42c6-80b6-f5ca51b32679.jpg",
  },
  {
    isTop: true,
    _id: "674c642e8ae1c4c2bb64d4cb",
    title_eng: "Express Samarkand-Bukhara Tour (2 Days)",
    title_ru: "Самарканд-Бухара за 2 дня",
    title_uz: "Ekspress Samarqand-Buxoro turi (2 kun)",
    description_eng:
      "<p>An efficient private route from Tashkent to Samarkand and Bukhara with Afrosiyob train tickets, sightseeing, transfers, and hotel included.</p>",
    description_ru:
      "<p>Компактный маршрут из Ташкента в Самарканд и Бухару с билетами на Афросиаб, экскурсиями, трансферами и проживанием.</p>",
    description_uz:
      "<p>Toshkentdan Samarqand va Buxoroga qisqa, ammo boy dasturli sayohat. Afrosiyob, transfer, ekskursiya va mehmonxona kiritilgan.</p>",
    location: "Toshkent, Samarqand, Buxoro",
    price: 500,
    img: "https://tur.web-sayt.uz/uploads/878654ae-3ff9-468a-b7fc-a29a2f2fcd69.jpg",
  },
  {
    isTop: true,
    _id: "674c74b38ae1c4c2bb64d591",
    title_eng: "Tashkent-Khiva-Bukhara-Samarkand (7 Days)",
    title_ru: "Ташкент - Хива - Бухара - Самарканд (7 дней)",
    title_uz: "Toshkent - Xiva - Buxoro - Samarqand (7 kun)",
    description_eng:
      "<p>Explore the Silk Road in one polished itinerary with guided highlights, intercity transport, comfortable stays, and a flexible pace.</p>",
    description_ru:
      "<p>Путешествие по Шелковому пути с ключевыми городами, сопровождением, транспортом между городами и комфортным размещением.</p>",
    description_uz:
      "<p>Ipak yo‘li shaharlarini yagona qulay dasturda ko‘ring: gid, shaharlararo transport va qulay yashash joylari bilan.</p>",
    location: "Toshkent, Xiva, Buxoro, Samarqand",
    price: 1000,
    img: "https://tur.web-sayt.uz/uploads/ff079203-bc06-46ac-8d60-18ea7566c89d.jpg",
  },
];

const galleryImages = [
  "https://cdn.tripster.ru/thumbs2/bd866670-b5c1-11ee-b8f5-3221ccd796ca.1600x900.jpeg",
  "https://voyage-wonder.com/wp-content/uploads/2022/10/face.jpg",
  "https://people-travels.com/storage/images/d1ZupoLogtRiRdEocPqkc9Kgad6PdahsvbbXathF.webp",
  "https://uzbekistan.travel/storage/app/uploads/public/679/715/ec1/679715ec17e87731132870.png",
  "https://uzbekistan.travel/storage/app/media/uploaded-files/photo_2024-07-01_12-11-20.jpg",
  "/img/slider/s11.jpg",
  "https://tripplanet.ru/wp-content/uploads/asia/uzbekistan/tashkent/dostoprimechatelnosti-tashkenta.jpg",
  "https://uzbekistan.travel/storage/app/media/noviy/DJI_0004.jpg",
  "https://uzbekistan.travel/storage/app/media/citys/5e53c06ca0049049451193.jpg",
];

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [bookShow, setBookShow] = useState(false);
  const [popular, setPopular] = useState(fallbackPopularTours);
  const [data, setData] = useState(null);
  const lang = localStorage.getItem("lang") || "en";

  useEffect(() => {
    fetch("https://tur.web-sayt.uz/api/tours/popular", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl9pZCI6ImJlODdiMjYwLTFhMTEtNDY0MC1iMzdkLTk4ZmI5YzQ5ZmI2NSIsInVzZXJfaWQiOiI2Mzg4ZWU0NWIxMzk5MTU2OWM0ZTdiMzAiLCJpYXQiOjE2NzIwNjYyNzd9.v22ZaaX_ZFrVIlWf6gaF7w1q1U3x0VJxiGYTKpDpeEI",
      },
    })
      .then((res) => res.json())
      .then(() => {
        setPopular(fallbackPopularTours);
      })
      .catch(() => {
        setPopular(fallbackPopularTours);
      });
  }, []);

  const getTourTitle = (tour) => {
    if (lang === "ru") return tour.title_ru;
    if (lang === "uz") return tour.title_uz;
    return tour.title_eng;
  };

  const getTourDescription = (tour) => {
    if (lang === "ru") return tour.description_ru;
    if (lang === "uz") return tour.description_uz;
    return tour.description_eng;
  };

  const formBtn = (e) => {
    e.preventDefault();
    if (!data) return;

    const botMessege = `
Здравствуйте, администратор ${companyInfo.brandName}, новое сообщение! 😊%0A
Название тура: ${data.title_eng}%0A
Имя: ${e.target[0].value}%0A
Фамилия: ${e.target[1].value}%0A
Телефон: ${e.target[2].value}%0A
`;

    const url = `https://api.telegram.org/bot7859889008:AAHIkSdCOwbYoxmTwIble9J2FXlAKES8vRk/sendMessage?chat_id=-4871883873&text=${botMessege}`;

    fetch(url).finally(() => {
      setBookShow(false);
      e.target.reset();
    });
  };

  return (
    <div>
      <SweetAlert
        title={t("info")}
        show={bookShow}
        onCancel={() => setBookShow(false)}
        showConfirm={false}
      >
        <form onSubmit={formBtn}>
          <input className="form-control" placeholder={t("name")} required />
          <input
            className="form-control"
            style={{ margin: "10px 0" }}
            placeholder={t("surname")}
            required
          />
          <input
            className="form-control"
            style={{ margin: "10px 0" }}
            placeholder={t("number")}
            required
          />
          <button className="money glow-on-hover" type="submit">
            {t("send")}
          </button>
        </form>
      </SweetAlert>

      <div className="progress-wrap cursor-pointer">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>

      <Nav />

      <header
        className="header slider-fade hero-panel"
        style={{ backgroundImage: 'url("/img/temur.png")' }}
      >
        <div className="hero-overlay" />
        <div className="v-middle caption hero-content">
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-12">
                <div className="hero-copy">
                <span className="hero-kicker">{companyInfo.brandName}</span>
                <h1 className="hero_text">{t("mekka")}</h1>
                <p className="hero-description">{t("enjoy")}</p>
                <div className="hero-actions">
                  <a className="hero-button primary" href="#tours">
                    {t("book")}
                  </a>
                  <a className="hero-button secondary" href="#about">
                    {t("about")}
                  </a>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="home-intro-strip">
        <div className="container">
          <div className="intro-grid">
            <div className="intro-card">
              <IoLocationOutline />
              <div>
                <strong>{t("intro_routes_title")}</strong>
                <p>{t("intro_routes_text")}</p>
              </div>
            </div>
            <div className="intro-card">
              <IoCheckmarkCircleOutline />
              <div>
                <strong>{t("intro_service_title")}</strong>
                <p>{t("intro_service_text")}</p>
              </div>
            </div>
            <div className="intro-card">
              <IoDocumentTextOutline />
              <div>
                <strong>{t("intro_docs_title")}</strong>
                <p>{t("intro_docs_text")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tours3 section-padding bg-lightnav" id="tours">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-subtitle">
                <span>{t("choose")}</span>
              </div>
              <div className="section-title">
                {t("popu")} {t("tours")}
              </div>
            </div>
          </div>
          <div className="row tour-grid">
            {popular.map((tour) => (
              <div className="col-lg-4 col-md-6" key={tour._id}>
                <article className="card tour-card">
                  <Link to={`/${tour._id}`} className="tour-card-media">
                    <img src={tour.img} alt={tour.title_eng} />
                  </Link>
                  <div className="tour-card-body">
                    <div className="tour-card-topline">
                      <span className="tour-card-tag">{t("business_tour")}</span>
                      <span className="tour-card-price">${tour.price}</span>
                    </div>
                    <div className="tour-location">
                      <IoLocationOutline />
                      <span>{tour.location}</span>
                    </div>
                    <h3
                      className="tour-card-title"
                      onClick={() => navigate(`/${tour._id}`)}
                    >
                      {getTourTitle(tour)}
                    </h3>
                    <div
                      className="tour-card-description"
                      dangerouslySetInnerHTML={{ __html: getTourDescription(tour) }}
                    />
                    <div className="tour-card-actions">
                      <button
                        className="money tour-cta"
                        onClick={() => {
                          setData(tour);
                          setBookShow(true);
                        }}
                      >
                        {t("book")}
                      </button>
                      <button
                        className="tour-link-button"
                        onClick={() => navigate(`/${tour._id}`)}
                      >
                        {t("tdetail")}
                      </button>
                    </div>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="destination1 section-padding bg-lightnav" id="gallery">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-subtitle">{t("tdes")}</div>
              <div className="section-title">{t("odes")}</div>
            </div>
          </div>
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div
                className="item semi-card"
                key={index}
                style={{ backgroundImage: `url(${image})` }}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="about-section" id="about">
        <div className="container two-columns">
          <div className="left-column about-story">
            <span className="section-subtitle">{t("about")}</span>
            <h2 className="section-title about-title">{companyInfo.brandName}</h2>
            <p className="about-text">
              <strong>{companyInfo.brandName}</strong> individual va kichik guruh
              sayohatlarini tashkil etadi. Saytda endi aniq headerlar, bir xil
              kartalar va foydalanuvchi uchun yengilroq navigatsiya bor.
            </p>
            <p className="about-text">
              Tarixiy shaharlar, biznes safarlar, transfer, mehmonxona va tayyor
              marshrutlar bir xil premium uslubda taqdim etiladi.
            </p>
            <div className="about-highlights">
              <div className="about-highlight">
                <IoCallOutline />
                <span>{companyInfo.phone}</span>
              </div>
              <div className="about-highlight">
                <IoMailOutline />
                <span>{companyInfo.email}</span>
              </div>
              <div className="about-highlight">
                <IoGlobeOutline />
                <span>{companyInfo.websiteLabel}</span>
              </div>
            </div>
          </div>

          <div className="right-column company-details-card">
            <h3 className="sub-title">Kompaniya rekvizitlari</h3>
            <ul className="info-list">
              <li>
                <strong>To‘liq nomi:</strong> {companyInfo.legalName}
              </li>
              <li>
                <strong>Tashkiliy shakli:</strong> {companyInfo.legalType}
              </li>
              <li>
                <strong>Manzil:</strong> {companyInfo.fullAddress}
              </li>
              <li>
                <strong>STIR:</strong> {companyInfo.stir}
              </li>
              <li>
                <strong>Reestr raqami:</strong> {companyInfo.registrationNumber}
              </li>
              <li>
                <strong>Ro‘yxatdan o‘tgan sana:</strong> {companyInfo.registrationDate}
              </li>
              <li>
                <strong>Hudud:</strong> {companyInfo.region}
              </li>
              <li>
                <strong>Telefon:</strong>{" "}
                <a href={companyInfo.phoneHref}>{companyInfo.phone}</a>
              </li>
              <li>
                <strong>Email:</strong> {companyInfo.email}
              </li>
              <li>
                <strong>Veb-sayt:</strong>{" "}
                <a href={companyInfo.website}>{companyInfo.websiteLabel}</a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
